import {
  FETCH_TAGS_LIST,
  FETCH_FILTERED_TAGS_LIST,
  FETCH_FORM_TAGS_LIST,
  FETCH_TAGS_PER_PAGE_LIST,
  FETCH_TAG,
  UPDATE_TAGS,
  UPDATE_SELECTED_TAGS,
  CREATE_TAG,
  DELETE_TAG,
  DELETE_TAGS
} from "./types";
import { sortSearchPaginateActions } from "@/store/common/actions";
import * as tagsApi from "@/api-client/tag";

import { createNewTagsFromLocal, loadingMutations } from "@/store/utils";
import { convertDataFromApi } from "@/utils/util";

export default {
  async fetchTagsList(
    { commit },
    { search, onSuccess, page = 1, queryString } = {}
  ) {
    commit({
      type: FETCH_TAGS_LIST.request
    });

    try {
      const resp = await tagsApi.fetchTagsList({ search, page, queryString });
      const { items } = resp;
      commit({
        type: FETCH_TAGS_LIST.success,
        payload: items
      });
      onSuccess && onSuccess(items);
      return items;
    } catch (e) {
      commit({
        type: FETCH_TAGS_LIST.error,
        error: e.message
      });
    }
  },

  async fetchFilteredTagsList(
    { commit },
    { search, onSuccess, page = 1, queryString } = {}
  ) {
    commit({
      type: FETCH_FILTERED_TAGS_LIST.request
    });

    try {
      const resp = await tagsApi.fetchTagsList({ search, page, queryString });
      const { items } = resp;
      commit({
        type: FETCH_FILTERED_TAGS_LIST.success,
        payload: items
      });
      onSuccess && onSuccess(items);
      return items;
    } catch (e) {
      commit({
        type: FETCH_FILTERED_TAGS_LIST.error,
        error: e.message
      });
    }
  },
  
  async fetchFormTagsList(
    { commit },
    { search, onSuccess, page = 1, queryString } = {}
  ) {
    commit({
      type: FETCH_FORM_TAGS_LIST.request
    });

    try {
      const resp = await tagsApi.fetchTagsList({ search, page, queryString });
      const { items } = resp;
      commit({
        type: FETCH_FORM_TAGS_LIST.success,
        payload: items
      });
      onSuccess && onSuccess(items);
      return items;
    } catch (e) {
      commit({
        type: FETCH_FORM_TAGS_LIST.error,
        error: e.message
      });
    }
  },

  async fetchTagsPerPageList(
    { commit },
    { search, onSuccess, onError, page = 1, queryString } = {}
  ) {
    commit({
      type: FETCH_TAGS_PER_PAGE_LIST.request
    });

    try {
      const resp = await tagsApi.fetchTagsList({ search, page, queryString });
      const { items } = resp;
      commit({
        type: FETCH_TAGS_PER_PAGE_LIST.success,
        payload: items
      });
      onSuccess && onSuccess(items);
      return items;
    } catch (e) {
      commit({
        type: FETCH_TAGS_PER_PAGE_LIST.error,
        error: e.message
      });
      onError ? onError(e.message) : null;
    }
  },

  async fetchTagById({ commit }, { id, onSuccess, onError }) {
    commit({
      type: FETCH_TAG.request
    });

    try {
      const tag = await tagsApi.fetchTagById(id);
      commit({
        type: FETCH_TAG.success,
        payload: tag
      });
      onSuccess && onSuccess(tag);
      return tag;
    } catch (e) {
      commit({
        type: FETCH_TAG.error,
        error: e.message
      });
    }
  },

  updateTags({ commit }, data) {
    commit({
      type: UPDATE_TAGS,
      payload: data
    });
  },

  async createTag({ commit }, { payload, onSuccess, onError } = {}) {
    commit({
      type: CREATE_TAG.request
    });

    try {
      const tag = await tagsApi.createTag(payload);

      commit({
        type: CREATE_TAG.success,
        payload: tag
      });

      onSuccess ? onSuccess(tag) : null;
      return tag;
    } catch (e) {
      commit({
        type: CREATE_TAG.error,
        error: e.message
      });

      onError ? onError(e.message) : null;
    }
  },

  updateSelectedTags({ commit, dispatch }, { tags }) {
    commit({
      type: UPDATE_SELECTED_TAGS,
      payload: tags
    });
  },

  async deleteTag({ commit }, { tagId, onSuccess, onError } = {}) {
    commit({
      type: DELETE_TAG.request
    });

    try {
      await tagsApi.deleteTag(tagId);

      commit({
        type: DELETE_TAG.success,
        payload: tagId
      });

      onSuccess ? onSuccess(tagId) : null;
      return tagId;
    } catch (e) {
      commit({
        type: DELETE_TAG.error,
        error: e.message
      });

      onError ? onError(e.message) : null;
    }
  },

  async deleteTags({commit}, {idsArr, onSuccess, onError} = {}) {
    commit({
      type: DELETE_TAGS.request
    });
    let idsStr = idsArr.join(',');
    try {
      await tagsApi.deleteTags(idsStr);
      commit({
        type: DELETE_TAGS.success,
        payload: idsStr
      })
      onSuccess ? onSuccess(idsArr) : null;
      return idsArr;
    } catch (e) {
      commit({
        type: DELETE_TAGS.error,
        error: e.message
      })
      onError ? onError(e.message) : null;
    }
  },

  ...sortSearchPaginateActions,
  ...loadingMutations([FETCH_TAGS_LIST.request, CREATE_TAG.request])
};
